<template>
    <div>
        <CustomersTable :query="{ gateway: gatewayId }" :excludeColumns="['ID Sage', 'Code Visibble']">
            <template #actions="{ customer }">
                <sui-button class="tiny" v-on:click="goToConfiguration(customer)">{{ $t('common.config') }}</sui-button>
            </template>
        </CustomersTable>
    </div>
</template>

<script>
import CustomersTable from '@/components/customers/CustomersTable.vue';
import store from '@/store';
import { mapGetters } from 'vuex';

export default {
    name: 'GatewayCustomers',
    components: {
        CustomersTable
    },
    beforeDestroy() {
        store.commit('removeAppTitle');
    },
    mounted() {
        store.commit('setAppTitle', `${this.$t('common.agencies')}`);
    },
    data() {
        return {
            isLoading: false,
            state: store.state,
            gatewayId: this.$route.params.gateway_id,
        }
    },
    computed: {
        ...mapGetters([
            'activeGateway',
        ])
    },
    async created() {
        this.isLoading = true;

        await store.dispatch('getGatewayById', this.$route.params.gateway_id);

        store.commit('setAppTitle', `${this.$t('common.agencies')} - ${this.activeGateway.name}`);

        this.isLoading = false;
    },
    methods: {
        goToConfiguration(customer) {
            this.$router.push({
                name: 'CustomerGatewaysList',
                params: {
                    customer_id: customer.id
                }
            })
        },
    },
}
</script>
